import React from 'react';

const CustomField = ({ render }) => {
  return render ? render() : <></>;
};

export default CustomField;
